import React from 'react';
import PropTypes from 'prop-types';
import styles from '../App.module.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.section} style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <h2>Something went wrong</h2>
          <p>We experienced an unexpected error. Please refresh the page to try again.</p>
          <button 
            className={styles.ctaButton}
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '2rem', color: 'var(--text-light)' }}>
              <summary>Error Details (Development Only)</summary>
              <pre>{this.state.error?.toString()}</pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
